import { Modal } from "components";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import FreeFieldProfileModalPicker from "components/Picker/FreefieldProfile/FreefieldProfileModalPicker";
import React from "react";

interface Props {
  isOpen: boolean
  onClose: () => void
  userToClient: server.dto.UserToClientSmall
}

interface FormState {
  freeFieldProfile: server.dto.FreeFieldProfileSmall
}

export const ReactivateUserForExternalModal = (props: Props) => {
  const [formState, setFormState] = React.useState<FormState>({
    freeFieldProfile: null,
  });

  const onChange = (newData: Partial<FormState>) => {
    setFormState((prevState) => ({
      ...prevState,
      ...newData,
    }));
  }

  const submit = () => window.CoreApi.UserForExternalAdmin.Reactivate({
    userToClientId: props.userToClient.userToClientId,
    freeFieldProfileId: formState.freeFieldProfile.freeFieldProfileId,
  })

  const onSuccess = () => {
    window.location.reload();
  }

  return <Modal width="tiny" title={RESX.SoUser.ReactivateAccount} handleClose={props.onClose} isOpen={props.isOpen}>
    <EditSectionTemplate
      submit={submit}
      saveButtonLabel={RESX.SoUser.ReactivateAccount}
      noPanels
      onSuccess={onSuccess}
      sections={[{
        key: "reactivateAccount",
        type: "regular",
        title: RESX.SoUser.ReactivateAccount,
        fields: [{
          key: "name",
          label: RESX.GeneralLabels.Name,
          renderEditNew: () => <div className="main-section-template-fields-padding">
            {props.userToClient.user.fullName}
          </div>
        }, {
          key: "freeFieldPermissionProfileLabel",
          label: RESX.SoUser.Permissions,
          hideLabel: true,
          renderEditNew: () => <div className="main-section-template-fields-padding">
            <h3>{RESX.SoUser.Permissions}</h3>
          </div>
        }, {
          key: "freeFieldPermissionProfile",
          label: RESX.FreeField.PermissionProfile,
          renderEditNew: () => <div className="main-section-template-fields-padding">
            <FreeFieldProfileModalPicker
              environment="external"
              canCreateNew={false}
              nonInPageEditing={{
                onChange: v => onChange({ freeFieldProfile: v }),
                value: formState.freeFieldProfile,
                validatorKey: "freeFieldProfile",
                required: true,
              }}
            />
          </div>,
        }]
      }]}
    />
  </Modal>
}